<script>
import appConfig from "@/app.config";
export default {
  props: {
    blog: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      assetsPath: appConfig.assetsPath,
    };
  },
  methods: {
    getImgUrl(img) {
      if (img) {
        if (img.indexOf("http") > -1) {
          return img;
        }
        return this.assetsPath + "images/" + img;
      }
      return "";
    },
    getBlog(route) {
      return this.GLOBAL.hrefLink(`blogs/${route}`)
    },
  },
};
</script>

<template>
  <div
    :class="$style.blogCard"
    class="d-flex flex-column w-100 rounded-14 card-shadow"
  >
    <div :class="[$style.cover]" class="d-flex">
      <img :src="getImgUrl(blog.image)" />
    </div>
    <div :class="$style.bodyContent" class="d-flex flex-column w-100">
      <div
        class="d-flex w-100"
        :class="[$style.category, blog.colorClass]"
        :style="blog.colorClass"
      >
        {{ blog.category }}
      </div>
      <h2 class="d-flex w-100">
        <a :href="getBlog(blog.route)">{{ blog.title }}</a>
      </h2>
    </div>
  </div>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.blogCard {
  overflow: hidden;
  .cover {
    position: relative;
    overflow: hidden;
    padding-bottom: 200px;
    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
      left: 0;
      top: 0;
      right: 0;
    }
  }
  h2 {
    margin-bottom: 0;
    line-height: 28px;
    a {
      text-decoration: none;
      color: $color-dark-gray;
      font-family: $family-bold;
      font-size: 20px;
    }
  }
  .category {
    font-size: 14px;
    margin-bottom: 15px;
    font-family: $family-bold;
  }
  .bodyContent {
    padding: 30px 30px 40px;
    background-color: $white;
  }
}
</style>
